import Vue from 'vue';
import Router, { Route } from 'vue-router';
import { EBankIdSigningType, EBankIdStep } from '@signing-page/signing/types/enums/bankid-se';
import {
  actionSetPreviewToken,
  actionLoadTokenSuccess,
} from '@signing-page/session/store/session.actions';
import { SigningHelper } from '@signing-page/signing/helpers/signing.helper';
import { namespace as sessionNamespace } from '@signing-page/session/store/session.store';
import {
  ESigningAction,
  namespace as signingNamespace,
} from '@signing-page/signing/store/signing.constants';
import { actionSetIds, actionSetPreviewMode } from '@signing-page/store/actions';
import { getGlobalHandle } from '@/common/helpers';
import Signing from '@signing-page/pages/Signing.vue';
import store from '@signing-page/store/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: getGlobalHandle()._basePath,
  routes: [
    {
      path: '/signing-page/v3/preview/:documentId',
      meta: { title: 'Signing', signingType: 'v3', preview: true },
      component: Signing,
    },
    {
      path: '/v/preview/:documentId',
      meta: { title: 'Signing', signingType: 'v3', preview: true },
      component: Signing,
    },
    {
      path: '/v3/preview/:documentId',
      meta: { title: 'Signing', signingType: 'v3', preview: true },
      component: Signing,
    },
    {
      path: '/signing-page/v3/:documentId/:recipientId/a/:authId/video/:videoId?',
      meta: { title: 'Signing', signingType: 'v3' },
      component: Signing,
    },
    {
      path: '/v3/:documentId/:recipientId/a/:authId/video/:videoId?',
      meta: { title: 'Signing', signingType: 'v3', urlType: 'v3' },
      component: Signing,
    },
    {
      path: '/v/:documentId/:recipientId/a/:authId/video/:videoId?',
      meta: { title: 'Signing', signingType: 'v3', urlType: 'v' },
      component: Signing,
    },
    {
      path: '/signing-page/v3/:documentId/:recipientId/a/:authId/',
      meta: { title: 'Signing', signingType: 'v3' },
      component: Signing,
    },
    {
      path: '/v3/:documentId/:recipientId/a/:authId/',
      meta: { title: 'Signing', signingType: 'v3', urlType: 'v3' },
      component: Signing,
    },
    {
      path: '/v/:documentId/:recipientId/a/:authId/',
      meta: { title: 'Signing', signingType: 'v3', urlType: 'v' },
      component: Signing,
    },
  ],
});

router.beforeEach(async (to: Route, from: Route, next) => {
  const { recipientId, documentId, userId, authId, videoId }: any = to.params;
  const { token, orderRef, step, signingType, autoStartToken } = to.query;
  const { preview } = to.meta;

  store.dispatch(actionSetIds, {
    documentId,
    recipientId,
    authId,
    userId,
    videoReminderId: videoId,
  });
  const hasBankIdParams: boolean = SigningHelper.hasValidBankIdParams(
    orderRef as string,
    step as EBankIdStep,
    signingType as EBankIdSigningType,
    autoStartToken as string
  );
  if (hasBankIdParams) {
    store.dispatch(`${signingNamespace}/${ESigningAction.SetBankIdQueryParams}`, {
      orderRef,
      step,
      signingType,
      autoStartToken,
    });
  }
  if (preview) {
    store.dispatch(actionSetPreviewMode, true);
    if (token) {
      store.dispatch(`${sessionNamespace}/${actionSetPreviewToken}`, token, {
        root: true,
      });
    }
  } else if (token && !preview) {
    store.dispatch(`${sessionNamespace}/${actionLoadTokenSuccess}`, {
      token: { jwt: token },
    });
  }
  if (token || hasBankIdParams) {
    return router.push(to.path);
  }

  return next();
});

export default router;
